import { ReactNode, useState } from 'react'

import { AstraAlertDialog } from '~/astra'

export type ConfirmActionOptions = {
    title: string
    description: ReactNode
    cancelButtonLabel: string
    confirmButtonLabel: string
}

type Confirmation = ConfirmActionOptions & {
    resolve: (confirmed: boolean) => void
}

export const useConfirmAction = () => {
    const [confirmation, setConfirmation] = useState<Confirmation | null>(null)

    const confirm = (options: ConfirmActionOptions) =>
        new Promise<boolean>(resolve => {
            setConfirmation({ ...options, resolve })
        })

    const closeConfirmation = (confirmed: boolean) => {
        const resolve = confirmation?.resolve
        setConfirmation(null)
        resolve?.(confirmed)
    }

    const confirmDialog = (
        <AstraAlertDialog
            isOpen={confirmation !== null}
            title={confirmation?.title ?? ''}
            description={confirmation?.description ?? ''}
            confirmButtonLabel={confirmation?.confirmButtonLabel ?? ''}
            cancelButtonLabel={confirmation?.cancelButtonLabel ?? ''}
            onConfirm={() => closeConfirmation(true)}
            onCancel={() => closeConfirmation(false)}
        />
    )

    return { confirm, confirmDialog }
}
